import React, { useState } from 'react'
import { useRecoilValue } from 'recoil'
import { isEmptyString } from 'utils/common-util'
import { getMessage } from 'utils/message-util'
import useModal from 'hook/useModal'
import { userInfoState } from 'store/atom/user-state-atom'

// css
import 'assets/style/components/comment-modal.scss'

// elements
import { IconButton } from 'components'

function Component({
  className,
  placeholder = '입력하세요.',
  disabled = false,
  onRegist = () => {},
  ntcAtclId,
  registMutation,
}) {
  const userInfo = useRecoilValue(userInfoState)

  const { alertModal, confirmModal, closeModal } = useModal()
  const [focus, setFocus] = useState(false)
  const [cmntCn, setCmntCn] = useState('')

  const handleFocus = () => {
    setFocus(!focus)
  }

  const clickRegist = () => {
    if (isEmptyString(cmntCn)) {
      alertModal(getMessage('common_validation_004', { target: '댓글' }))
      return
    }
    registMutation.mutate({
      ntcAtclId: ntcAtclId,
      cmntCn: cmntCn,
      useYn: 'Y',
      regrId: userInfo.userId,
    })

    setCmntCn('')

    // onRegist(
    //   {
    //     cmntCn: cmntCn,
    //     useYn: 'Y',
    //   },
    //   () => {
    //     setCmntCn('')
    //   },
    // )
  }

  return (
    <div className={`comment-modal ${focus === true ? 'focused' : ''}`}>
      <input
        tabIndex="-1"
        type="text"
        className={'input-text ' + className}
        placeholder={placeholder}
        disabled={disabled}
        onFocus={handleFocus}
        onBlur={handleFocus}
        value={cmntCn}
        onChange={(e) => {
          setCmntCn(e.target.value)
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            clickRegist()
          }
        }}
      />
      {focus || cmntCn.length > 0 ? (
        <IconButton
          type="message"
          size="40"
          color="green"
          onClick={clickRegist}
          style={{ right: process.env.REACT_APP_NODE_ENV === 'local' ? '40px' : '' }}
        />
      ) : (
        <></>
      )}
    </div>
  )
}

export default Component
